export const DELETE_BULK_SESSION = "DELETE_BULK_SESSION";
export const DELETE_BULK_SESSION_SUCCESS = "DELETE_BULK_SESSION_SUCCESS";
export const DELETE_BULK_SESSION_ERROR = "DELETE_BULK_SESSION_ERROR";
export const RESET_DELETE_BULK_SESSION = "RESET_DELETE_BULK_SESSION";

export interface DeleteBulkSession {
  type: typeof DELETE_BULK_SESSION;
  payload: { idSessions: number[], action_notification_message?: string, notify_action?: boolean };
}

export interface DeleteBulkSessionSuccess {
  type: typeof DELETE_BULK_SESSION_SUCCESS;
  payload: null;
}

export interface DeleteBulkSessionError {
  type: typeof DELETE_BULK_SESSION_ERROR;
  payload: string | boolean;
}

export interface ResetDeleteBulkSession {
  type: typeof RESET_DELETE_BULK_SESSION;
  payload: null;
}

export interface State {
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | DeleteBulkSession
  | DeleteBulkSessionSuccess
  | DeleteBulkSessionError
  | ResetDeleteBulkSession;
